<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      checkValidation: checkValidation$ | async,
    };
    as data
  ) {
    @if (isLoadingProjektparter()) {
      <div class="overlay">
        <div class="overlay-loader">
          <div class="loader"></div>
        </div>
      </div>
    }
    @if (!isLoadingProjektparter() && projektparter()) {
      <div class="intro-text">
        <strong
          [innerHTML]="
            question().translations?.list['headLine']
              | translate: data.activeLang : question().structure.headLine
          "
        ></strong>
        <div
          [innerHTML]="
            question().translations?.list['description']
              | translate: data.activeLang : question().structure.description
          "
        ></div>
      </div>
      <div class="coordinator-container">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <p class="heading-size-4 mb-0">
            {{ t('question_budget_coordinator_header') }}
          </p>
          @if (
            canImportUpparbetadeKostnader() &&
            data.readOnly === ReadonlyState.Editable
          ) {
            <button
              vinnova-button-text
              type="button"
              (click)="openUpparbetadeKostnaderImport()"
            >
              <lib-icon name="upload" size="small"></lib-icon>
              Importera upparbetade kostnader från Excel
            </button>
          }
        </div>
        <ng-container
          *ngTemplateOutlet="
            projektpartTablesTemplate;
            context: {
              worksite: projektparter().koordinator,
              coordinator: true,
              inactive: inaktivaParter.has(projektparter().koordinator.id),
            }
          "
        ></ng-container>
      </div>

      @if (projektparter().projektparter.length > 0) {
        <div class="projektparter-container">
          <div class="d-flex justify-content-between align-items-center">
            <p class="heading-size-4">
              <strong>{{ t('question_budget_participants_header') }}</strong>
            </p>

            <div class="d-flex justify-content-end d-none d-md-flex">
              <button vinnova-button-text (click)="toggleCollapseAll(true)">
                <lib-icon name="maximize-2" size="small"></lib-icon>
                {{ t('question_budget_expand_all') }}
              </button>
              <button vinnova-button-text (click)="toggleCollapseAll(false)">
                <lib-icon name="minimize-2" size="small"></lib-icon>
                {{ t('question_budget_minimize_all') }}
              </button>
            </div>
          </div>

          @for (projektpart of projektparter().projektparter; track $index) {
            <div class="projektpart">
              <ng-container
                *ngTemplateOutlet="
                  projektpartTablesTemplate;
                  context: {
                    worksite: projektpart,
                    coordinator: false,
                    inactive: inaktivaParter.has(projektpart.id),
                  }
                "
              ></ng-container>
            </div>
          }
        </div>
      }

      <div class="total">
        <p class="heading-size-4">
          {{ t('question_budget_total_header') }}
        </p>

        <div class="total-budget-container">
          <lib-interactive-table
            [id]="question().id + '_total'"
            [hideExpand]="true"
            [rows]="KOSTNADSSLAG"
            [columns]="columns()"
            [tierTwoColumnHeaders]="tierTwoColumnHeaders()"
            [sumCol]="true"
            [readonly]="true"
            [readonlyData]="totalUpparbetadeKostnader()"
            [tableContentToRight]="true"
            [disableResize]="true"
            size="medium"
            [readOnly$]="readOnly$"
            [hideValidation]="data.readOnly === ReadonlyState.Reader"
            [borderLeft]="true"
            [browseLarge]="browseLarge()"
            [browseMedium]="browseMedium()"
            [browseSmall]="browseSmall()"
            [mobileTableHeading]="t('question_budget_kostnader_table_header')"
            [showToggle]="showToggle"
            [toggleActiveText]="t('projekt_budget_hide_year')"
            [toggleInactiveText]="t('projekt_budget_show_year')"
            (toggleOutput)="toggle($event)"
          ></lib-interactive-table>
        </div>
      </div>

      @if (showAterbetalningskrav()) {
        <div class="aterbetalningskrav d-none d-md-block">
          <p class="heading-size-4">
            {{ t('question_budget_aterbetalningskrav_title') }}
          </p>
          <p>
            {{ t('question_budget_aterbetalningskrav_description') }}
          </p>
          <table class="table aterbetalningskrav-table">
            <thead>
              <tr>
                @for (header of aterbetalningskravHeaders; track $index) {
                  <th>
                    <div
                      [class]="
                        $index !== 0 && $index !== 5
                          ? 'aterbetalningskrav-header-container'
                          : $index === 5
                            ? 'aterbetalningskrav-header-slutligt'
                            : ''
                      "
                    >
                      <span
                        [class]="
                          $index === 4 || $index === 5
                            ? 'aterbetalningskrav-header-text'
                            : ''
                        "
                      >
                        {{ t(header) }}
                      </span>
                      @if ($index === 4) {
                        <lib-icon
                          name="info"
                          class="lib-icon"
                          size="x-small"
                          [libTooltip]="
                            t(
                              'question_budget_aterbetalningskrav_ackumulerade_kostnader'
                            )
                          "
                          triggers="hover-persist"
                        ></lib-icon>
                      } @else if ($index === 5) {
                        <lib-icon
                          name="info"
                          size="x-small"
                          [libTooltip]="
                            t(
                              'question_budget_aterbetalningskrav_slutligt_bidrag_explanation'
                            )
                          "
                          triggers="hover-persist"
                        ></lib-icon>
                      }
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{{ projektparter().koordinator.company.name }}</th>
                @for (index of [0, 1, 2, 3, 4, 5]; track index) {
                  <td>
                    {{
                      aterbetalningskravTableValues.get(
                        projektparter().koordinator.id
                      )
                        ? (aterbetalningskravTableValues.get(
                            projektparter().koordinator.id
                          )[index] | customCurrency)
                        : ''
                    }}
                  </td>
                }
              </tr>
              @for (
                projektpart of projektparter().projektparter;
                track projektpart.id
              ) {
                <tr>
                  <th>{{ projektpart.company.name }}</th>
                  @for (index of [0, 1, 2, 3, 4, 5]; track index) {
                    <td>
                      {{
                        aterbetalningskravTableValues.get(projektpart.id)[index]
                          | customCurrency
                      }}
                    </td>
                  }
                </tr>
              }
              <tr>
                <th>
                  {{ t('question_budget_aterbetalningskrav_total') }}
                </th>
                @for (index of [0, 1, 2, 3, 4, 5]; track index) {
                  <td>
                    {{
                      aterbetalningskravTableValues.get('total')
                        ? (aterbetalningskravTableValues.get('total')[index]
                          | customCurrency)
                        : ''
                    }}
                  </td>
                }
              </tr>
            </tbody>
          </table>
          <ng-container
            *ngTemplateOutlet="aterbetalningskravSummary"
          ></ng-container>
        </div>

        <div class="aterbetalningskrav d-md-none">
          <button
            class="aterbetalningskrav-header collapse-header"
            (click)="aterbetalningskravOpen = !aterbetalningskravOpen"
            [attr.aria-expanded]="aterbetalningskravOpen"
            aria-controls="aterbetalningskrav-body"
          >
            <div class="d-flex justify-content-between">
              <span class="heading-size-5 m-0">
                {{ t('question_budget_aterbetalningskrav_title') }}
              </span>
              <div>
                @if (aterbetalningskravOpen) {
                  <lib-icon
                    name="minus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                } @else {
                  <lib-icon
                    name="plus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                }
              </div>
            </div>
          </button>
          <div
            [libCollapse]="!aterbetalningskravOpen"
            id="aterbetalningskrav-body"
            class="collapse-body"
          >
            <p>
              {{ t('question_budget_aterbetalningskrav_description') }}
            </p>
            <ng-container
              *ngTemplateOutlet="aterbetalningskravSummary"
            ></ng-container>
            <button
              vinnova-button-primary
              class="w-100 open-table-button"
              (click)="openAterbetalnignskravModal()"
            >
              {{ t('question_table_open') }}
            </button>
          </div>
        </div>
      }

      <ng-template
        #projektpartTablesTemplate
        let-worksite="worksite"
        let-coordinator="coordinator"
        let-inactive="inactive"
      >
        @if (
          {
            formControl: formControls.get(worksite?.id),
          };
          as worksiteData
        ) {
          <div class="projektpart-container">
            <button
              class="projektpart-header collapse-header"
              [ngClass]="data.readOnly ? 'readonly' : ''"
              (click)="isOpen.set(worksite.id, !isOpen.get(worksite.id))"
              [class.is-open]="isOpen.get(worksite?.id)"
              [attr.disabled]="disabled ? true : undefined"
              [attr.aria-label]="
                inactive
                  ? worksite.company.name +
                    ' ' +
                    t('question_budget_actual_inactive')
                  : worksite.company.name
              "
              [attr.aria-expanded]="isOpen.get(worksite.id)"
              [attr.aria-controls]="'projektpart-' + worksite.id"
              [attr.aria-invalid]=""
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="header-text text-start">
                  <span
                    class="heading-size-5"
                    [class.text-decoration-line-through]="inactive"
                    >{{ worksite.company.name }}
                    @if (inactive) {
                      <span>{{
                        ' - ' + t('question_budget_actual_inactive')
                      }}</span>
                    }
                  </span>
                  <div
                    class="header-contact-info d-flex mt-3 mt-lg-0 justify-content-between"
                  >
                    <span>{{
                      worksite.company.nationalRegistrationNumber ??
                        worksite.company.vat
                    }}</span>
                    <div class="divider d-none d-lg-block"></div>
                    <div class="break d-block d-lg-none"></div>
                    <span>{{ worksite.name }}</span>
                    <div class="divider d-none d-lg-block"></div>
                    <div class="break d-block d-lg-none"></div>
                    <div>
                      @if (
                        worksite.address && worksite.zipcode && worksite.city
                      ) {
                        <span
                          >{{ worksite.address }},
                          {{ worksite.zipcode | zipCode }}
                          {{ worksite.city }},</span
                        >
                      }
                      @if (worksite.country) {
                        <span>
                          {{
                            worksite.country
                              | translatedCountry: data.activeLang
                          }}</span
                        >
                      }
                    </div>
                    @if (worksite.phone) {
                      <div class="divider d-none d-lg-block"></div>
                    }

                    <div class="break d-block d-lg-none"></div>
                    <span>{{ worksite.phone }}</span>
                  </div>
                </div>

                @if (isOpen.get(worksite.id)) {
                  <lib-icon
                    name="minus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                } @else {
                  <lib-icon
                    name="plus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                }
              </div>
            </button>
            <div
              [libCollapse]="!isOpen.get(worksite.id)"
              [attr.id]="'projektpart-' + worksite.id"
              (visible)="isVisible.set(worksite.id, $event)"
            >
              <div
                class="projektpart-body collapse-body"
                [ngClass]="data.readOnly ? 'readonly' : ''"
              >
                @if (isVisible.get(worksite.id)) {
                  <div class="projektpart-table">
                    <lib-interactive-table
                      [id]="question().id + '_' + worksite.id"
                      [title]="worksite.company.name"
                      [rows]="KOSTNADSSLAG"
                      [columns]="columns()"
                      [tierTwoColumnHeaders]="tierTwoColumnHeaders()"
                      [sumCol]="true"
                      [formControl]="worksiteData.formControl"
                      [tableContentToRight]="true"
                      [inputType]="InputType.Amount"
                      [expansionTitle]="worksite.company.name"
                      [expansionSubTitle]="
                        coordinator
                          ? t('question_budget_coordinator')
                          : undefined
                      "
                      [tableValidation]="['BudgetNoCostsReportedWarning']"
                      [tableRowValidation]="
                        kostnaderRowValidation.get(worksite.id)
                      "
                      [disableResize]="true"
                      (saveExpanded)="updateBudgetTables($event, worksite.id)"
                      size="medium"
                      [totalHeading]="
                        t('question_budget_total_kostnader_header')
                      "
                      suffix="SEK"
                      [readOnly$]="readOnly$"
                      [readonly]="isSharedView"
                      [defaultValue]="0"
                      [readonlyData]="ackumulerat.get(worksite.id)"
                      [hideValidation]="data.readOnly === ReadonlyState.Reader"
                      [allowMinus]="true"
                      [touched]="
                        data.checkValidation || tableClosed.get(worksite.id)
                      "
                      [browseLarge]="browseLarge()"
                      [browseMedium]="browseMedium()"
                      [browseSmall]="browseSmall()"
                      [mobileTableHeading]="
                        t('question_budget_kostnader_table_header')
                      "
                      [showToggle]="showToggle"
                      [toggleActiveText]="t('projekt_budget_hide_year')"
                      [toggleInactiveText]="t('projekt_budget_show_year')"
                      (toggleOutput)="toggle($event)"
                    ></lib-interactive-table>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </ng-template>

      <ng-template #aterbetalningskravSummary>
        <div
          class="aterbetalning-summary"
          [class.warning]="aterbetalningskrav() > 0"
        >
          @if (redanAterbetalt() > 0) {
            <div class="d-flex justify-content-between">
              <span
                >{{ t('question_budget_aterbetalningskrav_redan_aterbetalat') }}
                <lib-icon
                  name="info"
                  size="small"
                  [libTooltip]="
                    t(
                      'question_budget_aterbetalningskrav_redan_aterbetalat_explanation'
                    )
                  "
                  triggers="hover-persist"
                ></lib-icon
              ></span>
              <span>{{ redanAterbetalt() | customCurrency }}</span>
            </div>
          }
          @if (ejUtbetalt() > 0) {
            <div class="d-flex justify-content-between">
              <span>{{
                t('question_budget_aterbetalningskrav_ejutbetalt')
              }}</span>
              <span>{{ ejUtbetalt() | customCurrency }}</span>
            </div>
          }
          <div class="d-flex justify-content-between fw-bold">
            <span>
              @if (roundAterbetalningskrav() > 0) {
                <lib-icon
                  name="alert-triangle"
                  class="aterbetalning-warning-icon"
                ></lib-icon>
                {{ t('question_budget_aterbetalningskrav_belopp_tillbaka') }}*
              } @else if (aterbetalningskrav() === 0) {
                {{ t('question_budget_aterbetalningskrav_belopp_tillbaka') }}
              } @else {
                {{
                  t('question_budget_aterbetalningskrav_kommande_utbetalning')
                }}
              }
            </span>
            <span>{{ aterbetalningskrav() | absolute | customCurrency }}</span>
          </div>
        </div>
        @if (aterbetalningskrav() > 0) {
          <p class="aterbetalning-terms">
            *{{ t('question_budget_aterbetalningskrav_terms') }}
          </p>
        }
      </ng-template>

      <ng-template #aterbetalningskravExpandedModal>
        <lib-modal class="aterbetalningskrav-modal">
          <span class="aterbetalningskrav-modal-title">{{
            t('question_budget_aterbetalningskrav_title')
          }}</span>
          <div class="table-browse">
            <span>{{ t('question_budget_aterbetalningskrav_browse') }}: </span
            ><button
              vinnova-button-primary
              class="browse-button"
              size="small"
              (click)="
                aterbetalningskravBrowseIndex =
                  aterbetalningskravBrowseIndex - 1
              "
              [disabled]="aterbetalningskravBrowseIndex === 1"
              [attr.aria-label]="t('question_table_browse_prev')"
            >
              <lib-icon name="chevron-left"></lib-icon></button
            ><button
              vinnova-button-primary
              class="browse-button ms-2"
              size="small"
              (click)="
                aterbetalningskravBrowseIndex =
                  aterbetalningskravBrowseIndex + 1
              "
              [disabled]="aterbetalningskravBrowseIndex === 6"
              [attr.aria-label]="t('question_table_browse_next')"
            >
              <lib-icon name="chevron-right"></lib-icon>
            </button>
          </div>

          <table class="table aterbetalningskrav-table mobile">
            <thead>
              <tr>
                <th>{{ t(aterbetalningskravHeaders[0]) }}</th>
                <th>
                  {{
                    t(aterbetalningskravHeaders[aterbetalningskravBrowseIndex])
                  }}
                  @if (aterbetalningskravBrowseIndex === 4) {
                    <lib-icon
                      name="info"
                      size="x-small"
                      [libTooltip]="
                        t(
                          'question_budget_aterbetalningskrav_ackumulerade_kostnader'
                        )
                      "
                      triggers="hover-persist"
                    ></lib-icon>
                  } @else if (aterbetalningskravBrowseIndex === 5) {
                    <lib-icon
                      name="info"
                      size="x-small"
                      [libTooltip]="
                        t(
                          'question_budget_aterbetalningskrav_slutligt_bidrag_explanation'
                        )
                      "
                      triggers="hover-persist"
                    ></lib-icon>
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{{ projektparter().koordinator.company.name }}</th>
                <td>
                  {{
                    aterbetalningskravTableValues.get(
                      projektparter().koordinator.id
                    )[aterbetalningskravBrowseIndex - 1] | customCurrency
                  }}
                </td>
              </tr>
              <tr>
                <th>{{ t('question_budget_aterbetalningskrav_total') }}</th>
                <td>
                  {{
                    aterbetalningskravTableValues.get('total')[
                      aterbetalningskravBrowseIndex - 1
                    ] | customCurrency
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <ng-container
            *ngTemplateOutlet="aterbetalningskravSummary"
          ></ng-container>
          <button
            vinnova-button-primary
            class="w-100 close-button"
            (click)="aterbetalningskravModalRef.hide()"
          >
            {{ t('question_budget_aterbetalningskrav_close_table') }}
          </button>
        </lib-modal>
      </ng-template>
    }
  }
</ng-container>
